import { render, staticRenderFns } from "./Manufacturing.vue?vue&type=template&id=63720736&scoped=true&"
import script from "./Manufacturing.vue?vue&type=script&lang=js&"
export * from "./Manufacturing.vue?vue&type=script&lang=js&"
import style0 from "./Manufacturing.vue?vue&type=style&index=0&id=63720736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63720736",
  null
  
)

export default component.exports